import { render, staticRenderFns } from "./DesiredSpaceTable.vue?vue&type=template&id=62253f25"
import script from "./DesiredSpaceTable.vue?vue&type=script&lang=js"
export * from "./DesiredSpaceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports